import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';

import EmailInterstitialForm from './EmailInterstitialForm';
import {
    onSubscribeComplete,
    skipInterstitialPopup
} from '../../containers/Widget/actions';
import { CardTypes } from '../../utils/enums';
import { cacheFormData } from '../../utils/formCaching/actions';
import { copyFor } from '../../copy/copy';

const AnimationContainer = styled.div`
    &.transition-enter {
        opacity: 0;
    }

    &.transition-enter.transition-enter-active {
        transition: opacity 0.35s;
        transition-timing-function: ease-out;
        opacity: 1;
    }

    &.transition-exit {
        opacity: 1;
    }

    &.transition-exit.transition-exit-active {
        transition: opacity 0.25s;
        transition-timing-function: ease-out;
        opacity: 0;
    }
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 2;
`;

const Body = styled.div`
    width: 436px;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 4px 8px 0 rgba(42, 42, 42, 0.1);
    padding: 1.5em;
    background-color: rgba(255, 255, 255, 1);
    border: 1px solid #f1f1f1;

    @media (max-width: 30em) {
        width: calc(100% - 2em);
    }
`;
const EmailInterstitialPopup = props => (
    <AnimationContainer>
        <Container>
            <Body>
                <EmailInterstitialForm
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.onSubscribeComplete(
                            values,
                            props.activeAction.type,
                            props.activeAction.collectEmailFor,
                            props.isMultiActionsCard,
                            props.skipSuccessNavigation
                        );
                    }}
                    isEmailSubmitting={props.isEmailSubmitting}
                    skipInterstitialPopup={() =>
                        props.skipInterstitialPopup(
                            props.activeAction.type,
                            props.isMultiActionsCard,
                            props.skipSuccessNavigation
                        )
                    }
                    skipLinkVisible={props.skipLinkVisible}
                    collectEmailText={props.collectEmailText}
                />
            </Body>
        </Container>
    </AnimationContainer>
);

EmailInterstitialPopup.propTypes = {
    onSubscribeComplete: PropTypes.func.isRequired,
    isEmailSubmitting: PropTypes.bool,
    activeAction: PropTypes.object,
    skipInterstitialPopup: PropTypes.func,
    skipLinkVisible: PropTypes.bool,
    isMultiActionsCard: PropTypes.bool,
    skipSuccessNavigation: PropTypes.bool,
    collectEmailText: PropTypes.string,
    cacheFormData: PropTypes.func.isRequired
};

export default connect(
    state => ({
        isEmailSubmitting: state.widget.isEmailSubmitting,
        activeAction: state.widget.activeAction,
        skipLinkVisible: state.widget.activeAction.collectEmail === 1,
        isMultiActionsCard:
            state.widget.cards[state.widget.activeAction.order - 1].type ===
            CardTypes.multipleActions,
        collectEmailText:
            state.widget.activeAction.collectEmailText !== undefined
                ? state.widget.activeAction.collectEmailText
                : copyFor('emailInterstitial', 'collectEmailText')
    }),
    { onSubscribeComplete, skipInterstitialPopup, cacheFormData }
)(EmailInterstitialPopup);



// WEBPACK FOOTER //
// ./src/components/EmailInterstitial/EmailInterstitialPopup.jsx